import { render, staticRenderFns } from "./Offline_training.vue?vue&type=template&id=20ccf2b6"
import script from "./Offline_training.vue?vue&type=script&lang=js"
export * from "./Offline_training.vue?vue&type=script&lang=js"
import style0 from "./Offline_training.vue?vue&type=style&index=0&id=20ccf2b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports